import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import moment from 'moment';
import Service from '../../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';
import LoadingComponent from '../../loadingComponent';
import ClassetDropdown from '../../../classetComponents/classetDropDown';
import ClassetInputText from '../../../classetComponents/classetInputText';
import ClassetCalendar from '../../../classetComponents/classetCalender';
import ClassetMultiSelect from '../../../classetComponents/classetMultiSelect';
import ClassetTextArea from '../../../classetComponents/classetTextArea';
import BranchToSectionDD from '../../BaseDropdownComponents/BranchToSectionDD';
import './styles.scss';

class AdHocCharges extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            feeTypes: [],
            students: [],
            charges: [],
            summary: { totalAssigned: 0, totalPaid: 0, totalBalance: 0, totalCount: 0 },
            selectedStudentIds: [],
            dropdownsData: {},
            formData: {
                feeTypeId: '',
                amount: '',
                dueDate: null,
                remarks: ''
            },
            editDialogVisible: false,
            editCharge: null
        };
        this.service = new Service();
        this.toast = React.createRef();
    }

    componentDidMount() {
        this.getFeeTypes();
        this.getCharges();
    }

    getArrayData = (response) => {
        const payload = response?.res?.data;
        if (Array.isArray(payload)) {
            return payload;
        }
        if (Array.isArray(payload?.response)) {
            return payload.response;
        }
        if (Array.isArray(payload?.records)) {
            return payload.records;
        }
        if (Array.isArray(payload?.data)) {
            return payload.data;
        }
        return [];
    };

    getFeeTypes = async () => {
        try {
            const academicYear = localStorage.getItem('userAcademicYear');
            const url = `${baseUrlAdmin}/fee-types?limit=1000&page=1&academicYear=${academicYear}`;
            const response = await this.service.get(url, true);
            if (response?.status && response?.res?.status) {
                const feeTypeRows = this.getArrayData(response);
                const feeTypes = feeTypeRows
                    .filter((item) => item?.isOneTime === true || item?.isOneTime === 'true' || item?.isOneTime === 1)
                    .map((item) => ({
                    label: `${item?.feeType}${item?.isOneTime ? ' (One Time)' : ''}`,
                    value: item?._id,
                    isOneTime: item?.isOneTime,
                    feeType: item?.feeType
                    }));
                this.setState({ feeTypes });
            }
        } catch (error) {
            this.toast.current?.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
        }
    };

    getStudents = async (dropdownsData) => {
        try {
            if (!dropdownsData?.branchId || !dropdownsData?.boardId || !dropdownsData?.classId || !dropdownsData?.sectionId) {
                this.setState({ students: [], selectedStudentIds: [] });
                return;
            }

            const academicYear = localStorage.getItem('userAcademicYear');
            const url = `${baseUrlAdmin}/fine/student`;
            const payload = {
                branchId: dropdownsData.branchId,
                boardId: dropdownsData.boardId,
                classId: dropdownsData.classId,
                sectionId: dropdownsData.sectionId,
                academicYear,
                status: 'Active'
            };

            const response = await this.service.post(url, payload, true);
            if (response?.status && response?.res?.status) {
                const studentRows = this.getArrayData(response);
                const students = studentRows.map((item) => ({
                    label: item?.name,
                    value: item?.user_id
                }));
                this.setState({ students });
            }
        } catch (error) {
            this.toast.current?.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
        }
    };

    getCharges = async () => {
        try {
            this.setState({ isLoading: true });
            const academicYear = localStorage.getItem('userAcademicYear');
            const { dropdownsData, selectedStudentIds } = this.state;
            const query = new URLSearchParams({
                academicYear,
                page: '1',
                limit: '100'
            });

            if (dropdownsData?.branchId) {
                query.set('branchId', dropdownsData.branchId);
            }
            if (selectedStudentIds?.length === 1) {
                query.set('user_id', selectedStudentIds[0]);
            }

            const url = `${baseUrlAdmin}/student-additional-charges?${query.toString()}`;
            const response = await this.service.get(url, true);
            if (response?.status && response?.res?.status) {
                const chargeRows = this.getArrayData(response);
                this.setState({
                    charges: chargeRows,
                    summary: response?.res?.summary || { totalAssigned: 0, totalPaid: 0, totalBalance: 0, totalCount: 0 },
                    isLoading: false
                });
            } else {
                this.setState({ isLoading: false });
            }
        } catch (error) {
            this.setState({ isLoading: false });
            this.toast.current?.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
        }
    };

    setDropdownValues = (dropdownsData) => {
        this.setState({ dropdownsData }, () => {
            this.getStudents(dropdownsData);
            this.getCharges();
        });
    };

    handleInputChange = (field, value) => {
        this.setState((prevState) => ({
            formData: {
                ...prevState.formData,
                [field]: value
            }
        }));
    };

    sanitizeAmountValue = (value) => {
        const raw = String(value || '');
        const cleaned = raw.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
        const [wholePart, decimalPart] = cleaned.split('.');
        if (decimalPart === undefined) {
            return wholePart;
        }
        return `${wholePart}.${decimalPart.slice(0, 2)}`;
    };

    handleAmountChange = (value) => {
        const sanitizedValue = this.sanitizeAmountValue(value);
        this.handleInputChange('amount', sanitizedValue);
    };

    handleEditAmountChange = (value) => {
        const sanitizedValue = this.sanitizeAmountValue(value);
        this.setState((prevState) => ({
            editCharge: {
                ...(prevState.editCharge || {}),
                amount: sanitizedValue
            }
        }));
    };

    handleCollectAmountChange = (value) => {
        const sanitizedValue = this.sanitizeAmountValue(value);
        this.setState({ collectAmount: sanitizedValue });
    };

    handleAssignCharges = async () => {
        try {
            const { dropdownsData, selectedStudentIds, formData } = this.state;
            if (!selectedStudentIds.length) {
                throw new Error('Select at least one student');
            }
            if (!formData.feeTypeId) {
                throw new Error('Select a fee type');
            }
            if (!formData.amount || Number(formData.amount) <= 0) {
                throw new Error('Enter a valid amount');
            }
            if (!formData.dueDate) {
                throw new Error('Enter due date');
            }

            this.setState({ isLoading: true });
            const payload = {
                academicYear: localStorage.getItem('userAcademicYear'),
                userIds: selectedStudentIds,
                feeTypeId: formData.feeTypeId,
                amount: Number(formData.amount),
                dueDate: formData.dueDate,
                remarks: formData.remarks,
                chargeSource: selectedStudentIds.length > 1 ? 'BULK' : 'MANUAL',
                branchId: dropdownsData?.branchId,
                boardId: dropdownsData?.boardId,
                classId: dropdownsData?.classId,
                sectionId: dropdownsData?.sectionId
            };

            const response = await this.service.post(`${baseUrlAdmin}/student-additional-charges`, payload, true);
            if (response?.status && response?.res?.status) {
                this.toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.res?.message || 'Additional charges assigned', life: 3000 });
                this.setState({
                    formData: { feeTypeId: '', amount: '', dueDate: null, remarks: '' }
                });
                await this.getCharges();
            } else {
                throw new Error(response?.res?.message || 'Failed to assign charges');
            }
        } catch (error) {
            this.toast.current?.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    openEditDialog = (rowData) => {
        this.setState({
            editDialogVisible: true,
            editCharge: {
                id: rowData?._id,
                amount: rowData?.amount,
                dueDate: rowData?.dueDate ? new Date(rowData.dueDate) : null,
                remarks: rowData?.remarks || ''
            }
        });
    };

    handleUpdateCharge = async () => {
        try {
            const { editCharge } = this.state;
            if (!editCharge?.id) {
                throw new Error('Select charge to update');
            }
            if (!editCharge?.amount || Number(editCharge.amount) <= 0) {
                throw new Error('Enter a valid amount');
            }
            this.setState({ isLoading: true });
            const payload = {
                academicYear: localStorage.getItem('userAcademicYear'),
                amount: Number(editCharge.amount),
                dueDate: editCharge.dueDate,
                remarks: editCharge.remarks
            };
            const response = await this.service.put(`${baseUrlAdmin}/student-additional-charges/${editCharge.id}`, payload, true);
            if (response?.status && response?.res?.status) {
                this.toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Charge updated successfully', life: 3000 });
                this.setState({ editDialogVisible: false, editCharge: null });
                await this.getCharges();
            } else {
                throw new Error(response?.res?.message || 'Failed to update charge');
            }
        } catch (error) {
            this.toast.current?.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    cancelCharge = async (rowData) => {
        try {
            this.setState({ isLoading: true });
            const response = await this.service.delete(`${baseUrlAdmin}/student-additional-charges/${rowData?._id}`, true);
            if (response?.status && response?.res?.status) {
                this.toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Charge cancelled successfully', life: 3000 });
                await this.getCharges();
            } else {
                throw new Error(response?.res?.message || 'Failed to cancel charge');
            }
        } catch (error) {
            this.toast.current?.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    statusBody = (rowData) => rowData?.status || '-';

    studentBody = (rowData) => {
        const student = rowData?.studentSnapshot;
        if (student?.firstName || student?.lastName) {
            return `${student?.firstName || ''} ${student?.lastName || ''}`.trim();
        }
        return rowData?.studentInfo?.user_info?.firstName || rowData?.studentInfo?.user_info?.lastName || rowData?.user_id || '-';
    };

    feeTypeBody = (rowData) => rowData?.feeType || rowData?.feeTypeInfo?.feeType || '-';

    amountBody = (rowData) => `₹${Number(rowData?.amount || 0).toFixed(2)}`;

    balanceBody = (rowData) => `₹${Number(rowData?.balance || 0).toFixed(2)}`;

    dueDateBody = (rowData) => rowData?.dueDate ? moment(rowData.dueDate).format('DD-MM-YYYY') : '-';

    actionBody = (rowData) => {
        if (rowData?.status === 'PAID') return null;
        return (
            <div className="flex gap-2">
                <Button icon="pi pi-pencil" className="p-button-text p-button-sm" onClick={() => this.openEditDialog(rowData)} />
            </div>
        );
    };

    render() {
        const { isLoading, feeTypes, students, charges, summary, formData, selectedStudentIds, editDialogVisible, editCharge } = this.state;

        return (
            <div className="ad-hoc-charges-page">
                <Toast ref={this.toast} position="bottom-right" />

                <div className="ad-hoc-card">
                    <div className="ad-hoc-card-header">
                        <h3>Assign Charge</h3>
                        <Button label="Refresh" icon="pi pi-refresh" className="p-button-text" onClick={this.getCharges} />
                    </div>
                    <BranchToSectionDD selectedValue={1} setValues={this.setDropdownValues} />
                    <div className="ad-hoc-form-grid">
                        <div>
                            <ClassetDropdown
                                label="Fee Type"
                                required
                                value={formData.feeTypeId}
                                options={feeTypes}
                                onChange={(e) => this.handleInputChange('feeTypeId', e.target.value)}
                                placeholder={<span>Select Fee Type</span>}
                                width="100%"
                                height="48px"
                            />
                        </div>
                        <div>
                            <ClassetMultiSelect
                                label="Students"
                                required
                                value={selectedStudentIds}
                                options={students}
                                onChange={(e) => this.setState({ selectedStudentIds: e.value })}
                                placeholder="Select Student(s)"
                                width="100%"
                                height="48px"
                            />
                        </div>
                        <div>
                            <ClassetInputText
                                label="Amount"
                                required
                                type="text"
                                inputMode="decimal"
                                keyfilter="money"
                                value={formData.amount}
                                onChange={(e) => this.handleAmountChange(e.target.value)}
                                width="100%"
                                height="48px"
                                placeholder="Enter amount"
                            />
                        </div>
                        <div>
                            <ClassetCalendar
                                label="Due Date"
                                required
                                calendarMode="single"
                                value={formData.dueDate}
                                onChange={(e) => this.handleInputChange('dueDate', e.value)}
                                width="100%"
                                height="48px"
                            />
                        </div>
                        <div className="ad-hoc-remarks">
                            <ClassetTextArea
                                label="Remarks"
                                value={formData.remarks}
                                onChange={(e) => this.handleInputChange('remarks', e.target.value)}
                                width="100%"
                                height="96px"
                                placeholder="Optional remarks"
                            />
                        </div>
                    </div>
                    <div className="ad-hoc-actions">
                        <Button label="Assign Charge" icon="pi pi-plus" onClick={this.handleAssignCharges} />
                    </div>
                </div>

                <div className="ad-hoc-card mt-4">
                    <div className="ad-hoc-card-header">
                        <h3>Assigned Charges</h3>
                    </div>
                    <DataTable
                        value={charges}
                        dataKey="_id"
                        paginator
                        rows={10}
                        emptyMessage="No charges found"
                        responsiveLayout="scroll"
                    >
                        <Column header="Student" body={this.studentBody} />
                        <Column header="Fee Type" body={this.feeTypeBody} />
                        <Column header="Amount" body={this.amountBody} />
                        <Column header="Paid" body={(rowData) => `₹${Number(rowData?.amountPaid || 0).toFixed(2)}`} />
                        <Column header="Balance" body={this.balanceBody} />
                        <Column header="Due Date" body={this.dueDateBody} />
                        <Column header="Status" body={this.statusBody} />
                        <Column header="Actions" body={this.actionBody} />
                    </DataTable>
                </div>

                <Dialog
                    visible={editDialogVisible}
                    header="Update Charge"
                    onHide={() => this.setState({ editDialogVisible: false, editCharge: null })}
                    style={{ width: '42vw' }}
                >
                    <div className="ad-hoc-dialog-grid">
                        <ClassetInputText
                            label="Amount"
                            type="text"
                            inputMode="decimal"
                            keyfilter="money"
                            value={editCharge?.amount || ''}
                            onChange={(e) => this.handleEditAmountChange(e.target.value)}
                            width="100%"
                            height="48px"
                        />
                        <ClassetCalendar
                            label="Due Date"
                            calendarMode="single"
                            value={editCharge?.dueDate || null}
                            onChange={(e) => this.setState({ editCharge: { ...editCharge, dueDate: e.value } })}
                            width="100%"
                            height="48px"
                        />
                        <ClassetTextArea
                            label="Remarks"
                            value={editCharge?.remarks || ''}
                            onChange={(e) => this.setState({ editCharge: { ...editCharge, remarks: e.target.value } })}
                            width="100%"
                            height="96px"
                        />
                    </div>
                    <div className="flex justify-content-end gap-2 mt-3">
                        <Button label="Cancel" className="p-button-text" onClick={() => this.setState({ editDialogVisible: false, editCharge: null })} />
                        <Button label="Update" onClick={this.handleUpdateCharge} />
                    </div>
                </Dialog>


                {isLoading && <LoadingComponent />}
            </div>
        );
    }
}

export default AdHocCharges;
